import React from "react";
import menuIcon from "../../Assets/Icons/left_panel_close.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";
import LeftPanelClose from "../../Assets/SVGComponents/LeftPanelClose";

const Navbar = ({ title, collapsed, setCollapsed }) => {
  const navigate = useNavigate();

  return (
    <div className="navbar">
      <div className="header-wrapper">
        <div className="collapser" onClick={() => setCollapsed(!collapsed)}>
          <LeftPanelClose />
        </div>
        <div className="divider"></div>
        <div className="wrapper">
          <div className="title">{title}</div>
        </div>
      </div>
      <div className="bottom-divider"></div>
    </div>
  );
};

export default Navbar;
